import React, { createContext, useContext, useState, useEffect } from 'react';
import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';
import deTranslations from '../locales/de.json';
import itTranslations from '../locales/it.json';

const LanguageContext = createContext();

const translations = {
  en: enTranslations,
  fr: frTranslations,
  de: deTranslations,
  it: itTranslations
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language from localStorage or default to 'en'
    return localStorage.getItem('appLanguage') || 'en';
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('appLanguage', language);
  }, [language]);

  const t = (key, replacements = {}) => {
    // Navigate through nested object using dot notation
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    let result = value || key; // Return key as fallback if translation missing
    
    // Replace placeholders if any
    if (typeof result === 'string' && Object.keys(replacements).length > 0) {
      Object.keys(replacements).forEach(placeholder => {
        result = result.replace(new RegExp(`\\{${placeholder}\\}`, 'g'), replacements[placeholder]);
      });
    }
    
    return result;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
